// extracted by mini-css-extract-plugin
module.exports = {"game":"gameLogo__game___3nyqQ"};